import { fetchApiData } from '../../utils/apiUtils';
import { ENDPOINT } from '../../constants/api';
import * as memberSlice from '../slices/member.slice';
export const createMember = (businessSlug, data) => async dispatch => {
  const genderMap = new Map(
    Object.entries({
      ชาย: 1,
      หญิง: 2,
      ไม่ระบุ: 3
    })
  );
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/member`,
    data: {
      business_slug: businessSlug,
      gender_id: genderMap.get(data.gender),
      member_group_id: data.group === 'ไม่ระบุ' ? null : parseInt(data.group),
      tax_number: data.tax_id,
      company_name_th: data.company_name_th,
      first_name_th: data.first_name_th,
      last_name_th: data.last_name_th,
      phone_number: data.phone_number,
      entity_structure_id: data.entity_structure_id,
      birth_date: data.birthdate === '' ? null : data.birthdate
    },
    dispatch,
    useAuth: true
  });
  return response;
};
export const getAllMember =
  (businessSlug, search = null) =>
  async dispatch => {
    const data = await fetchApiData({
      method: 'get',
      endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/member/all/list`,
      dispatch,
      params: {
        s: search
      }
    });
    if (data) {
      dispatch(memberSlice.clearMember());
      dispatch(memberSlice.setMember(data));
      return data;
    }
  };
export const getMemberById = (businessSlug, id) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/member/${id}`,
    dispatch
  });
  if (data) {
    dispatch(memberSlice.clearIndividual());
    dispatch(memberSlice.setIndividualData(data));
    return data;
  }
};
export const getAllMemberGroup = businessSlug => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.MEMBERGROUP}/all/${businessSlug}/list`,
    dispatch
  });
  if (data) {
    dispatch(memberSlice.clearMemberGroup());
    dispatch(memberSlice.setMemberGroup(data));
    return data;
  }
};

export const updateOrderMember = (businessSlug, id, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/order/${id}/member`,
    data,
    dispatch,
    useAuth: true
  });

  return response;
};

export const removeOrderMember = (businessSlug, id, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'delete',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/order/${id}/member`,
    data,
    dispatch,
    useAuth: true
  });

  return response;
};
